import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {Shared} from "../shared/shared";
import {IonModal} from "@ionic/angular";
import {ContextService} from "../../service/ContextService";
import {ImagesService} from "../../service/ImagesService";
import {ImageEntity} from "../../model/ImageEntity";
import {PermissionEntity} from "../../model/PermissionEntity";
import {PermissionRoleEntity} from "../../model/PermissionRoleEntity";
import {PermissionsService} from "../../service/PermissionsService";
import {PermissionIntermediateEntity} from "../../model/PermissionIntermediateEntity";
import {RoleCourseDto} from "../../dto/RoleCourseDto";

@Component({
  selector: 'app-permissions',
  templateUrl: 'permissions.html',
  styleUrls: ['permissions.scss']
})
export class Permissions {

  constructor(private shared: Shared, private permissionsService: PermissionsService, private cdr: ChangeDetectorRef) {}

  @Input() changeCurrentRoles: boolean;
  @Input() parentId: number;
  @Input() parentType: string;
  @Input() currentParentRoleId: number;
  currentParentRole: PermissionRoleEntity;
  @Output() closeWindow = new EventEmitter<PermissionRoleEntity[]>();

  permissionsList: PermissionEntity[];
  rolesList: PermissionRoleEntity[];
  permissionsIntermediateList: PermissionIntermediateEntity[];

  rolesOfCourse: RoleCourseDto[];
  toChangeStudentRoles: RoleCourseDto[] = [];

  currentRole = null;
  isNew = false;

  ngOnInit(){
    this.permissionsService.getPermissions().subscribe(x=>{
      if(x!=null){
        this.permissionsList = x;
      }
    });

    this.permissionsService.getPermissionsRole().subscribe(x=>{
      if(x!=null){
        this.rolesList = x;
        if(this.changeCurrentRoles){
          this.currentParentRole = this.rolesList.find(f=> f.id == this.currentParentRoleId);
          this.permissionsService.getRolesOfCourse(this.parentId, this.parentType).subscribe(y=>{
            if(y!=null){
              this.rolesOfCourse = y;
            }
          });
        }
      }
    });

  }

  selectRole(role){
    this.isNew = false;
    this.permissionsService.getRoleIntermediate(role.id).subscribe(x=>{
      if(x!=null){
        this.permissionsIntermediateList = x;
        this.currentRole = role;
      }
    });
  }

  copyRol(rol){
    this.isNew = true;
    this.currentRole = new PermissionRoleEntity();
    this.currentRole.name = rol.name+'-copy';
    this.currentRole.alias = rol.alias+'-copy';
    this.currentRole.corpId = rol.corpId;
    this.permissionsService.getRoleIntermediate(rol.id).subscribe(x=>{
      if(x!=null){
        this.permissionsIntermediateList = x;
      }
    });
  }

  checkIsSelected(permissionId){
    let inter = this.permissionsIntermediateList.findIndex(p=> p.permissionId === permissionId);
    if(inter == -1){
      return false;
    }else{
      return true;
    }
  }

  checkIsSelectedToChange(roleId){
    let inter = this.toChangeStudentRoles.findIndex(p=> p.roleId === roleId);
    if(inter == -1){
      return false;
    }else{
      return true;
    }
  }

  trackByPermissionId(index: number, item: PermissionEntity): number {
    return item.id;
  }

  async clickOnPermission(permission){
    let inter = this.permissionsIntermediateList.findIndex(p=> p.permissionId === permission.id);
    if(inter == -1){
      let i = new PermissionIntermediateEntity();
      i.corpId = this.currentRole.corpId;
      i.permissionRoleId = this.currentRole.id;
      i.permissionId = permission.id;
      this.permissionsIntermediateList.push(i);
    }else{
      this.permissionsIntermediateList = this.permissionsIntermediateList.filter(f=> f.permissionId != permission.id);
    }
    await this.delay(200);
    this.cdr.detectChanges();
  }

  async clickOnRoleToChange(role){
    let inter = this.toChangeStudentRoles.findIndex(p=> p.roleId === role.roleId);
    if(inter == -1){
      this.toChangeStudentRoles.push(role);
    }else{
      this.toChangeStudentRoles = this.toChangeStudentRoles.filter(f=> f.roleId != role.roleId);
    }
    await this.delay(200);
    this.cdr.detectChanges();
  }

  savePermissionIntermediate(){
    this.permissionsService.savePermissionIntermediate(this.currentRole.id, this.permissionsIntermediateList).subscribe();
  }

  savePermissionRole(){
    this.permissionsService.saveRole(this.currentRole).subscribe();
  }

  savePermission(isNew){
      this.permissionsService.saveRole(this.currentRole).subscribe(y => {
        if (y != null) {
          this.currentRole = y;
          if(isNew) {
            this.rolesList.push(this.currentRole);
            this.permissionsIntermediateList = this.permissionsIntermediateList.map(m => {
              m.id = null;
              m.permissionRoleId = this.currentRole.id;
              return m;
            });
          }
          this.permissionsService.savePermissionIntermediate(this.currentRole.id, this.permissionsIntermediateList).subscribe();

          if(this.toChangeStudentRoles != null && this.toChangeStudentRoles.length > 0){
            this.permissionsService.saveStudentRole(this.parentId, this.parentType, this.currentRole.id, this.toChangeStudentRoles).subscribe();
          }

          this.closePopup();
        }
      });
  }

  closePopup(){
    this.closeWindow.emit(this.rolesList);
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
